import { render, staticRenderFns } from "./TwitchPlayer.vue?vue&type=template&id=ea05a0f2"
import script from "./TwitchPlayer.vue?vue&type=script&lang=js"
export * from "./TwitchPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports